import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useDefaultLayoutProps } from '../../layouts/DefaultLayout/useProps'
import { selectors } from '../../redux'

import { SuccessTemplateProps } from './index'

export const useSuccessTemplateProps = (): SuccessTemplateProps => {
  const { t } = useTranslation()
  const registerFormValues = useSelector(selectors.app.registerFormValues)

  const layoutProps = useDefaultLayoutProps()

  return useMemo(
    () => ({
      layout: layoutProps,
      titleDescription: {
        title: t('success.title', {
          name: `${registerFormValues!.firstName} ${registerFormValues!.lastName}`,
        }),
        description: t('success.description'),
        isCentered: true,
      },
    }),
    [layoutProps, registerFormValues, t]
  )
}
